import(/* webpackChunkName: "lotteryStage" */ '../../Styles/LotteryStage/lotteryStage.scss');
import(/* webpackChunkName: "link" */ 'Common/Frontend/components/atoms/link/link.scss');
import(/* webpackChunkName: "paginationSlickSlider" */ 'Feature/Common/code/Pagination/Styles/paginationSlickSlider.scss');


await import(/* webpackChunkName: "parents" */ 'Feature/Common/code/Scripts/Common/parents');

await import(/* webpackChunkName: "pagination" */ 'Feature/Common/code/Scripts/Pagination/pagination');

window.am = window.am || {};

window.am.lotteryStage = new function () {
    const lotterySlider = document.querySelectorAll('.lottery-stage__slider-elements.am-lottery-slider-inner');

    var that = this;

    var badges = function () {
        const $lotteryStageBadge = $(".lottery-stage__badge--items[data-slide-animation='true']");

        if ($lotteryStageBadge.length < 1) {
            return;
        }

        $lotteryStageBadge.not('.slick-initialized').slick({
            autoplay: true,
            arrows: false
        });
    };

    var footnote = function () {
        const $lotteryStage = $(".lottery-stage");
        const $footNoteTop = $lotteryStage.find(".lottery-stage__footnote .richtext[data-footnote='short']");
        const $footNoteBottom = $lotteryStage.find(".lottery-stage__footnote .richtext[data-footnote='long']");

        if ($footNoteTop) {


            const $footNoteTopLinks = $footNoteTop.find("a");
            // Add aria-expanded false to links
            $footNoteTopLinks.attr("aria-expanded", false);
            const $footNoteBottomID = $footNoteTopLinks.closest(".richtext").siblings(".richtext").attr("id");
            // Add aria-controls to links
            $footNoteTopLinks.attr("aria-controls", $footNoteBottomID);

            // FootNote Top
            $footNoteTop.on("click", function (e) {
                var $this = $(this);
                var arrow = $this.find(".lottery-stage__arrow");

                // Add aria-controls to links
                var $links = $this.find("a").attr("aria-expanded", true);
                var $sibling = $this.closest(".richtext").siblings(".richtext");

                if ($sibling.attr("aria-hidden") === "true") {
                    $sibling
                        .slideUp(300)
                        .attr("aria-hidden", false);
                    if (arrow) {
                        arrow[0].classList.add("active");
                    }

                } else {
                    $sibling
                        .slideDown(300)
                        .attr("aria-hidden", true);
                    $links.attr("aria-expanded", false);
                    if (arrow) {
                        arrow[0].classList.remove("active");
                    }
                }

                $sibling.slideToggle(300);
                e.preventDefault();
            });

            // FootNote Bottom
            $footNoteBottom.on("click", function (e) {
                var $this = $(this);
                var $sibling = $this.closest(".richtext").siblings(".richtext");

                if ($sibling.find("a").attr("aria-expanded") === "true") {
                    $sibling.find("a").attr("aria-expanded", false);
                }

                $this.slideToggle().attr("aria-hidden", true);
                e.preventDefault();
            });

        }
    };

    var slidedown = function () {
        const $lotteryStageSR = $(".lottery-stage");


        const $slideDownTop = $lotteryStageSR.find(".lottery-stage__slidedown .richtext[data-slidedown='short']");
        const $slideDownBottom = $lotteryStageSR.find(".lottery-stage__slidedown .richtext[data-slidedown='long']");
        const slideDownArrow = document.querySelector(".lottery-stage__slidedown__arrow");

        if ($slideDownTop) {
            const $slideDownTopLinks = $slideDownTop.find("a");
            // Add aria-expanded false to links
            $slideDownTopLinks.attr("aria-expanded", false);
            const $slideDownBottomID = $slideDownTopLinks.closest(".richtext").siblings(".richtext").attr("id");
            // Add aria-controls to links
            $slideDownTopLinks.attr("aria-controls", $slideDownBottomID);

            // Slidedown Top
            $slideDownTop.on("click", function (e) {
                var $this = $(this);

                // Add aria-controls to links
                var $links = $this.find("a").attr("aria-expanded", true);
                var $sibling = $this.closest(".richtext").siblings(".richtext");

                if ($sibling.attr("aria-hidden") === "true") {
                    $sibling
                        .slideUp(300)
                        .attr("aria-hidden", false);
                    slideDownArrow.classList.add("active");
                } else {
                    $sibling
                        .slideDown(300)
                        .attr("aria-hidden", true);
                    $links.attr("aria-expanded", false);
                    slideDownArrow.classList.remove("active");
                }

                $sibling.slideToggle(300);
                e.preventDefault();
            });

            // Slidedown Bottom
            if ($slideDownBottom) {
                $slideDownBottom.attr("style", "display: none");
            }
        }

    };

    //Set Image height fitting lottery-stage inner text element height. For special raffle phase 1 lottery stage content, when having slider in it.
    that.setStageImageHeight = (stage) => {
        let clientWidth = document.querySelector('body').clientWidth;

        if (clientWidth > 1022) {
            let lotteryStageContainerImg = stage.querySelector(".lottery-stage__image img");
            let lotteryStageTextBlock = stage.querySelector(".lottery-stage__text");
            let lotteryStageTextBlockHeight = lotteryStageTextBlock.clientHeight;
            let lotteryStageTextBlockPadding = 64;

            lotteryStageContainerImg.style['min-height'] = `${lotteryStageTextBlockHeight + lotteryStageTextBlockPadding}px`;
        }

        return
    }

    that.reinintLotterySlickSlider = () => {
        lotterySlider.forEach((slider) => {
            $(slider).not('.slick-initialized').slick({
                speed: 0,
                adaptiveHeight: false, // Set adaptiveHeight to false
                arrows: true,
                dots: true,
                appendDots: $(slider).parent().find(".pagination-dots"),
                prevArrow: $(slider).parent().find(".pagination-prev"),
                nextArrow: $(slider).parent().find(".pagination-next"),
                dotsClass: slider.childElementCount <= 3 ? "pagination-dots" : "hide",
                lazyLoad: "progressive"
            });

            $(slider).slick('setPosition');

            if (window.matchMedia("(max-width: 767px)").matches) {
                const sideSpace = (window.innerWidth - slider.parentNode.clientWidth) / 2;
                $(slider).css("margin-right", (-1 * sideSpace) + "px");
                $(slider).css("padding-right", sideSpace + "px");
            }
            else if (window.matchMedia("(max-width: 1024px)").matches) {
                const sideSpace = (window.innerWidth - slider.parentNode.clientWidth) / 2;
                $(slider).css("margin-right", (-1 * sideSpace) + "px");
                $(slider).css("padding-right", sideSpace + "px");
            } else {
                $(slider).css("margin-right", "0");
                $(slider).css("padding-right", "0");
            }
        });

        return;
    }

    var initSliderElements = function () {
        var mainStages = document.querySelectorAll('.lottery-stage');

        mainStages.forEach(function (stage) {
            var stageElements = stage.querySelectorAll('.lottery-stage__slider-element')
            var pagination = stage.querySelector(".pagination");

            if (pagination) {
                if (stageElements.length <= 1) {
                    pagination.remove();
                }
                else {
                    that.setTabindexForNavigation(stage);
                }
            }

            $(stage).find('img.lazyload').on('load', function () {
                that.setEqualContentHeight(stage);
                that.setStageImageHeight(stage);

            });

            window.addEventListener('resize', function () {
                that.setStageImageHeight(stage);
                setTimeout(() => {
                    that.setEqualContentHeight(stage);
                }, 50)

                if (stageElements && stageElements.length > 1 ) {
                    that.reinintLotterySlickSlider();
                }
            });

            window.addEventListener('orientationchange', function () {
                if (stageElements && stageElements.length > 1) {
                    that.reinintLotterySlickSlider();
                }
                that.setEqualContentHeight(stage);
            });
        });
    };

    that.setEqualContentHeight = function (stage) {
        var textboxes = stage.querySelectorAll('.lottery-stage__slider-element');
        var highestTextBox = 0;

        textboxes.forEach(function (textbox) {
            textbox.style.height = "auto";
        });

        textboxes.forEach(function (textbox) {
            if (textbox.offsetHeight > highestTextBox) {
                highestTextBox = textbox.offsetHeight;
            }
        });

        textboxes.forEach(function (textbox) {
            textbox.style.height = highestTextBox + "px";
        });

        return;
    }

    that.setTabindexForNavigation = function (stage) {
        var prev = stage.querySelector('.prev');
        var next = stage.querySelector('.next');

        if (prev && next) {
            prev.setAttribute('tabindex', '0');
            next.setAttribute('tabindex', '0');
        }
    }

    that.init = function () {
        that.reinintLotterySlickSlider();

        var sliders = document.querySelectorAll('.lottery-stage');

        if (sliders && sliders.length > 0) {
            badges();
            footnote();
            slidedown();
            initSliderElements();
        }

        //Set footnote background color according to the page color: white/grey, default is grey
        var lotteryPageBGGreyElement = document.querySelector('main.lottery-page--bg-grey');
        if (lotteryPageBGGreyElement) {
            var lotteryStageFootnoteElement = lotteryPageBGGreyElement.querySelectorAll('.lottery-stage__footnote--outer');
            lotteryStageFootnoteElement.forEach(x => x.setAttribute('data-background-color', 'color-primary100'));
        }

        //initiate elements' height setting functions on content ready
        let stateCheck = setInterval(() => {
            if (document.readyState === 'complete') {
                // document ready
                var mainStagesWithSliders = document.querySelectorAll('.lottery-stage');

                mainStagesWithSliders.forEach(function (stage) {
                    if (stage.querySelector('.lottery-stage__slider-elements')) {
                        that.setEqualContentHeight(stage);//yet not working at this point
                        that.setStageImageHeight(stage);
                    }
                });

                clearInterval(stateCheck);
                // document ready
            }
        }, 100);
    }

}

window.am.lotteryStage.init();